<template>
  <div class="main">
    <header class="header">
      <nav class="header_main">
        <div class="logo" @click="logoToIndex" v-html="imgHtml">
          <img style="width:110px;height: auto;"
               data-v-82b7485c src="http://qiniu.shujunjun.club/a32f96a0b09149ac87e4100f111bb51d" alt="oaim"/>
        </div>
        <div class="container">
          <ul>
            <li @mouseover="mOver($event)" @mouseleave="mOver($event)" id="works1" data-locale="works"
                @click="toIndex($event)">案例
            </li>
            <!--      暂时不做      -->
            <!--            <li @mouseover="mOver($event)" @mouseleave="mOver($event)" id="business1" data-locale="works"-->
            <!--                @click="toBusiness($event)">业务-->
            <!--            </li>-->
            <li @mouseover="mOver($event)" @mouseleave="mOver($event)" id="about1" data-locale="about"
                @click="toAbout($event)">关于
            </li>
            <li @mouseover="mOver($event)" @mouseleave="mOver($event)" id="contact1" data-locale="contact"
                @click="toConnect($event)">
              联系
            </li>
            <li @mouseover="mOver($event)" @mouseleave="mOver($event)" id="supply1" data-locale="news"
                @click="toSupply($event)">
              新闻
            </li>
            <li>
              <div class="btn_icon"
                   @click="changeAllLanguage">
                <p style="transform: translateX(2px)" class="cn" data-locale="cn">中</p>
                <p style="transform: translateY(-1px)">|</p>
                <p style="transform: translateX(-2px)" class="en" data-locale="en">英</p>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <header class="mb_header">
      <nav class="mb_top">
        <div class="mb_logo" @click="mb_logoTo">
          <img width="40%" height="auto" data-v-82b7485c
               src="http://qiniu.shujunjun.club/a451f893bd2049d1b4faa1b80baadb1f" alt="oaim"/>
        </div>
        <div class="mb_clear" @click="showPanner">
          <div class="one"></div>
          <div class="two"></div>
          <div class="three"></div>
        </div>
      </nav>
      <nav class="mb_main">
        <ul>
          <li @click="mb_to_index">
            <div id="works2" data-locale="works">案例</div>
          </li>
          <!--          暂时不开放-->
          <!--          <li @click="mb_to_business">-->
          <!--            <div id="business2" >业务</div>-->
          <!--          </li>-->
          <li @click="mb_to_about">
            <div id="about2" data-locale="about">关于</div>
          </li>
          <li @click="mb_to_contact">
            <div id="contact2" data-locale="contact">联系</div>
          </li>
          <li @click="mb_to_supply">
            <div id="supply2" data-locale="news">新闻</div>
          </li>
          <li>
            <div @click="changeAllLanguage" class="language">
              <div class="chinese" data-locale="chinese">中文</div>
              <div class="english" data-locale="english">英文</div>
            </div>
          </li>
        </ul>
      </nav>
    </header>

    <div class="main">
      <router-view/>
    </div>
    <footer class="foot_container" v-html="html"><!--v-html="html"-->
      <div class="foot" style="transform: translateY(-10px)">

        <div class="foot_recognize" style="font-size: 16px;height: 100px;">
          <p style="padding-top: 70px;">“ 你好！互相认识一下 ”</p>
        </div>

        <div class="foot_pic" style="height: 40px;">
          <!--<img style="width: 35px; height: auto;" src="http://qiniu.shujunjun.club/e88c8cffff734afd9420de122dfe2dc7"
               alt="联系我">-->
          <div style="display:inline-block;width: 50px;height: 30px;">
            <a href="https://www.zcool.com.cn/u/23068053" target="_blank">
              <img style="width: 32px;" src="https://qiniu.shujunjun.club/zk.svg" alt="be">
            </a>
          </div>
          <div style="display:inline-block;width: 50px;height: 30px;transform:scale(1.2,1.2) translateY(1px)">
            <a href="https://www.behance.net/1205919061oaim" target="_blank">
              <img style="width: 32px;" src="https://qiniu.shujunjun.club/behance.svg" alt="face">
            </a>
          </div>
        </div>

        <div class="foot_connect" style="height: 35px;">
          <p><span style="font-size: 13px;">电话：</span><span style="font-size: 14px;">13813043023</span> &nbsp;&nbsp;&nbsp;&nbsp;
            <span style="font-size: 13px;">邮箱：</span><span style="font-size: 15px;">miao@oaimdesign.com</span>&nbsp;&nbsp;&nbsp;&nbsp;
            <span style="font-size: 13px;">地址：</span><span style="font-size: 12px;">南京市江宁区百家湖科技产业园1幢230室</span></p>
        </div>

        <div class="foot_beian" style="height: 40px;font-size: 13px;">
          <p class="beian"><a href='https://beian.miit.gov.cn/#/Integrated/recordQuery'>苏ICP备19072415号-3</a></p>
        </div>


      </div>
    </footer>
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: "oaimFont";
}

a {
  text-decoration: none;
  color: black;
}

.main {
  width: 100% !important;
  height: auto;
  box-sizing: border-box;
}

img {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

.foot_left_btn img {
  width: 100%;
  height: auto;
}

.col_layout > img {
  display: inline;
  margin-left: 10px;
}

.col_layout > img:first-of-type {
  margin-bottom: 10px;
}

#app {
  font-family: "oaimFont";
  /*font-family: "Arial","Microsoft YaHei","黑体","宋体",sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: black;
}

.btn_icon > p {
  padding: 2px;
}

.header {
  display: block;
}

@media (min-width: 1250px) {
  .header_main {
    margin: 0 auto !important;
    transform: translateY(14mm);
    /*border: 1px solid blue;*/
    width: 1070px;
    max-width: 1070px;
    min-width: 1070px;
  }
}

@media (min-width: 1100px) and (max-width: 1249px) {
  /* 头部样式 */
  .header_main {
    margin: 0 auto !important;
    transform: translateY(14mm) ;
    /*border: 1px solid yellow;*/
    max-width: 910px;
    min-width: 910px;
    margin-left: 9% !important;
    /*margin-right: 20mm !important;*/
  }
}

@media (min-width: 501px) and (max-width: 1099px) {
  /* 头部样式 */
  .header_main {
    margin: 0 auto !important;
    transform: translateY(14mm) ;
    /*border: 1px solid red;*/
    padding-left: 10% !important;
    /*max-width: 800px;*/
    /*margin-right: 20mm !important;*/
  }
  .container{
    /*display: none;*/
    padding-right: 10% !important;
  }
}

.logo {
  transform: translateX(0mm);
}

.logo > img {
  width: 110px;
  height: auto;
}

.logo > img:hover {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.container {
  transform: translateX(0%);
  /*border: 1px solid green;*/
}

.foot_container {
  /*background-color: rgb(247, 247, 247);*/
}

.foot {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  font-size: 17px;
  text-align: center;
}

.foot_recognize {
  font-size: 35px;
  height: 150px;
}

.foot_recognize > p {
  padding-top: 80px;
}

.foot_pic {
  height: 100px;
}

.foot_pic img {
  width: 40px;
  height: 40px;
}

.foot_connect {
  height: 40px;
}

.foot_beian {
  height: 40px;
}

.foot_copyright {
  height: 40px;
}

.mb_header {
  display: none;
}

.contact_left_left img {
  width: 20%;
  height: auto;
}

@media (min-width: 100px) and (max-width: 500px) {
  .mb_header {
    display: block !important;
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
  }

  .mb_top {
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    justify-content: space-between;
    margin-top: 7% !important;
    margin-right: 3% !important;
    margin-left: 3% !important;
  }

  .mb_clear {
    transform: translateX(-25px);
    /*margin-right: 2% !important;*/
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    width: 30px;
    box-sizing: border-box;
    cursor: pointer;
    /*border: 1px solid red;*/
  }

  .mb_clear div {
    width: 25px;
    height: 4px;
    border-top: 2px solid black !important;
  }

  .mb_logo {
    display: flex;
    transform: translateX(20px);
    /*margin-left: 3% !important;*/
    /*transform: translateX(-28%);*/
  }

  .mb_logo > img {
    display: block;
    width: 90px;
  }

  .mb_main {
    height: 100%;
    position: fixed;
    width: 100%;
    background-color: rgb(255, 255, 255);
  }

  .mb_main ul {
    list-style: none;
    display: -webkit-flex;
    display: -moz-flex;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-top: 60px;
  }

  .mb_main ul li {
    display: flex;
    display: -moz-flex;
    display: -webkit-flex;
    justify-content: flex-start;
    margin-left: 10%;
    align-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 90px;
    font-size: 23px;
    font-weight: 200;
  }

  .mb_main ul li > div {
    width: 30%;
  }

  .header_main {
    display: none !important;
  }

  .header {
    display: block !important;
  }

  .mb_main {
    display: none;
  }

  /* 底部联系信息样式 */
  .foot {
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
    height: 220px;
    align-items: flex-start;
    align-content: flex-start;
    font-size: 10px;
  }
}

</style>
<style scoped>
/*@import "../../../static/css/oaim.css";*/
</style>
<script>
import $ from 'jquery'
// 引入i18n这个很重要，切换中英文更能依赖
//引入鼠标滚动依赖
import axios from 'axios'

export default {
  name: "Main",
  data() {
    return {
      baseFlag: true,
      isEng: true,
      html: '',
      imgHtml: '',
      isAble: true,
      showVideo: false,
      video: true,
      videoAddress: '',
      fullWidth: document.documentElement.clientWidth
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {},
  mounted() {
    this.loadProperties(this.baseFlag)
    // this.changeAllLanguage()
    this.getFooterData()
    this.getTopImg()
  },
  methods: {

    chanLan() {
      let lang = ''
      if (this.baseFlag) {
        lang = 'zh'
        $('#works2').html('案例');
        $('#works2').css('font-size', '13px');
        $('#works1').html('案例');
        $('#works1').css('font-size', '13px');
        $('#business1').html('业务');
        $('#business1').css('font-size', '13px');
        $('#business2').html('业务');
        $('#business2').css('font-size', '13px');
        $('#about1').html('关于');
        $('#about1').css('font-size', '13px');
        $('#about2').html('关于');
        $('#about2').css('font-size', '13px');
        $('#contact1').html('联系');
        $('#contact1').css('font-size', '13px');
        $('#contact2').html('联系');
        $('#contact2').css('font-size', '13px');
        $('#supply1').html('新闻');
        $('#supply1').css('font-size', '13px');
        $('#supply2').html('新闻');
        $('#supply2').css('font-size', '13px');
        $('.chinese').html('中文');
        $('.chinese').css('font-size', '13px');
        $('.english').html('英文');
        $('.english').css('font-size', '13px');
        $('.cn').html('中');
        $('.cn').css('font-size', '13px');
        $('.en').html('英');
        $('.en').css('font-size', '13px');
      } else {
        lang = 'en'
        $('#works1').html('works');
        $('#business1').html('business');
        $('#business2').html('business');
        $('#works2').html('works');
        $('#about1').html('about');
        $('#about2').html('about');
        $('#contact1').html('contact');
        $('#contact2').html('contact');
        $('#supply1').html('news');
        $('#supply2').html('news');
        $('.chinese').html('cn');
        $('.english').html('en');
        $('.cn').html('cn');
        $('.en').html('en');
      }
    },
    //获取屏幕宽度
    handleResize(event) {
      this.fullWidth = document.documentElement.clientWidth
    },
    // 获取图片地址
    getTopImg() {
      let that = this
      axios.get('/back/img/img').then(res => {

        that.imgHtml = res.data.data.message
      })
    },
    // 手机端事件
    showPanner() {
      // 控制是否显示
      if (this.isAble) {
        $('.mb_main').css({
          'display': 'block'
        })
        $('.mb_header').css({
          'background-color': 'rgba(255,255,255,1)'
        })
        $('.one').css({
          'transform': 'rotate(45deg) translateX(3px) translateY(2px)'
        })
        $('.two').css({
          'transform': 'rotate(-45deg) translateX(4px) '
        })
        $('.three').css({
          'display': 'none'
        })
        this.isAble = !this.isAble
      } else {
        $('.mb_main').css({
          'display': 'none'
        })
        $('.mb_header').css({
          'background-color': 'rgba(255,140,0,0)'
        })

        $('.one').css({
          'transform': 'rotate(0deg) translateX(0px) translateY(0px)'
        })
        $('.two').css({
          'transform': 'rotate(0deg) translateX(0px) '
        })
        $('.three').css({
          'display': 'block'
        })
        this.isAble = !this.isAble
      }

    },

    // 获取底部数据
    getFooterData() {
      let that = this
      axios.get('/back/footer/footer').then(res => {

        let data = res.data.data[0].message
        that.html = data
      })
    },
    //鼠标悬停事件
    mOver(res) {
      let tag = $(res.target)[0].innerText
      $(res.target)[0].innerText = this.changeLanguage(tag)
    },
    //中应为转换
    changeLanguage(res) {
      if (res === '案例') {
        return 'works'
      }
      if (res === '关于') {
        return 'about'
      }
      if (res === '联系') {
        return 'contact'
      }
      if (res === 'works') {
        return '案例'
      }
      if (res === 'about') {
        return '关于'
      }
      if (res === 'contact') {
        return '联系'
      }
      if (res === 'news') {
        return '新闻'
      }
      if (res === '新闻') {
        return 'news'
      }
      if (res === '业务') {
        return 'business'
      }
      if (res === 'business') {
        return '业务'
      }
    },

    changeAllLanguage() {
      debugger
      // 设置语言标识
      // this.changeFlag()
      this.baseFlag = !this.baseFlag
      let flag = this.baseFlag
      //改变样式
      this.changeClass(flag)
    },
    changeCss() {
      $('.one').css({
        'transform': 'rotate(0deg) translateX(0px) translateY(0px)'
      })
      $('.two').css({
        'transform': 'rotate(0deg) translateX(0px) '
      })
      $('.three').css({
        'display': 'block'
      })
    },
    logoToIndex() {
      $('.container ul').find('li').removeClass('selected')
      this.$router.push('/index/index')
    },
    mb_logoTo() {
      $('.mb_main').css({
        'display': 'none'
      })

      $('.mb_header').css({
        'background-color': 'rgba(255,140,0,0)'
      })

      this.changeCss()
      this.isAble = true
      this.$router.push('/')
    },
    //跳转事件1
    toIndex(event) {
      $(event.target).siblings('li').removeClass('selected')
      $(event.target).addClass('selected')
      this.$router.push('/index/cases')
    },
    // 跳转business
    toBusiness() {
      $(event.target).siblings('li').removeClass('selected')
      $(event.target).addClass('selected')
      this.$router.push('/index/business')
    },
    // 跳转到cases
    mb_to_index() {
      $('.mb_main').css({
        'display': 'none'
      })
      $('.mb_header').css({
        'background-color': 'rgba(255,140,0,0)'
      })

      this.changeCss()
      this.isAble = true
      this.$router.push('/index/cases')
    },

    mb_to_business() {
      $('.mb_main').css({
        'display': 'none'
      })
      $('.mb_header').css({
        'background-color': 'rgba(255,140,0,0)'
      })
      this.changeCss()
      this.isAble = true
      this.$router.push('/index/business')
    },

    mb_to_about() {
      $('.mb_main').css({
        'display': 'none'
      })
      $('.mb_header').css({
        'background-color': 'rgba(255,140,0,0)'
      })

      this.changeCss()
      this.isAble = true
      this.$router.push('/index/about')
    },
    //跳转事件2
    toAbout(event) {
      $(event.target).siblings('li').removeClass('selected')
      $(event.target).addClass('selected')
      this.$router.push('/index/about')
    },
    // 手机端跳转
    mb_to_contact() {
      $('.mb_main').css({
        'display': 'none'
      })
      $('.mb_header').css({
        'background-color': 'rgba(255,140,0,0)'
      })

      this.changeCss()
      this.isAble = true
      this.$router.push('/index/connect')
    },
    //跳转事件3
    toConnect(event) {
      $(event.target).siblings('li').removeClass('selected')
      $(event.target).addClass('selected')
      this.$router.push('/index/connect')
    },
    mb_to_supply() {
      $('.mb_main').css({
        'display': 'none'
      })
      $('.mb_header').css({
        'background-color': 'rgba(255,140,0,0)'
      })

      this.changeCss()
      this.isAble = true
      this.$router.push('/index/supply')
    },
    // 跳转新闻
    toSupply(event) {
      $(event.target).siblings('li').removeClass('selected')
      $(event.target).addClass('selected')
      this.$router.push('/index/supply')
    },
    //切换中英文核心方法
    loadProperties(flag) {

      //根据lang设置p标签背景颜色
      if (!flag) {
        // console.log('当前为英文')
        $('.btn_icon p:last-child').css({
          'color': 'black'
        })
        $('.btn_icon p:first-child').css({
          'color': 'rgba(119, 119, 120, 0.9)'
        })
      } else {
        // console.log('当前为中文')
        $('.btn_icon p:last-child').css({
          'color': 'rgba(119, 119, 120, 0.9)'
        })
        $('.btn_icon p:first-child').css({
          'color': 'black'
        })
      }

      this.chanLan()
    },
    //改变样式的方法
    changeClass(flag) {
      if (flag) {
        $('.btn_icon p:last-child').css({
          // 'background-color': 'rgb(220,220,220)',
          // 'border-left': '1px solid rgb(119,119,120)',
          'color': 'rgba(119, 119, 120, 0.9) !important'
        })
        $('.btn_icon p:first-child').css({
          // 'background-color': 'rgb(220,98,36)',
          // 'border-right': '1px solid rgb(119,119,120)',
          'color': 'black !important'
        })
        this.loadProperties(flag)
      } else {
        $('.btn_icon p:last-child').css({
          // 'background-color': 'rgb(220,98,36)',
          // 'border-left': '1px solid rgb(119,119,120) !important',
          'color': 'black !important'
        })
        $('.btn_icon p:first-child').css({
          // 'background-color': 'rgb(220,220,220)',
          // 'border-right': '1px solid rgb(119,119,120)',
          'color': 'rgba(119, 119, 120, 0.9) !important'
        })
        this.loadProperties(flag)
      }
    },
    toIndexPage() {
      this.video = !this.video
      this.showVideo = !this.showVideo
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Main/Main.vue